export default __webpack_public_path__ + "static/media/Calculator_icon.4fb79e6f.png";